import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const About = () => {
  return (
    <div className="about-page bg-light py-5">
      <Container>
        {/* Welcome Section */}
        <Row className="text-center mb-5">
          <Col>
            <h1 className="fw-bold">Welcome to [Your ATS AI Resume Scorer & Template Tool]</h1>
            <p className="fs-5">Your AI-powered platform to craft the perfect resume!</p>
          </Col>
        </Row>

        {/* What We Do Section */}
        <Row className="mb-5">
          <Col>
            <h2 className="fw-bold text-center">What We Do</h2>
            <p className="text-center">
              [Your Tool Name] helps you create professional, standout resumes. Our AI analyzes your resume 
              in real-time, ensuring it aligns with industry standards and job descriptions to maximize your chances.
            </p>
          </Col>
        </Row>

        {/* Features Section */}
        <Row className="text-center mb-5">
          {[
            { title: "AI Resume Scoring", text: "Get immediate feedback on resume quality, structure, content, and formatting." },
            { title: "Tailored Resume Templates", text: "Choose from industry-specific templates to create professional resumes." },
            { title: "Keyword Optimization", text: "Optimize your resume for ATS with relevant keywords to get noticed." }
          ].map((feature, index) => (
            <Col md={4} key={index} className="mb-4">
              <Card className="bg-dark text-white shadow-sm border-0 card-hover">
                <Card.Body>
                  <Card.Title className="fw-bold">{feature.title}</Card.Title>
                  <Card.Text>{feature.text}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Why Choose Us Section */}
        <Row className="mb-5">
          <Col>
            <h2 className="fw-bold text-center">Why Choose Us?</h2>
            <ul className="list-unstyled text-center fs-5">
              <li>✅ User-friendly design with an intuitive interface.</li>
              <li>✅ Real-time AI-driven insights to enhance your resume.</li>
              <li>✅ Tailored suggestions for your career and job role.</li>
              <li>✅ Stay ahead of industry trends and ATS best practices.</li>
            </ul>
          </Col>
        </Row>

        {/* Meet the Team Section */}
        <Row className="mb-5">
          <Col className="text-center">
            <h2 className="fw-bold">Meet the Team</h2>
            <p>We’re a diverse group of professionals passionate about helping job seekers succeed.</p>
          </Col>
        </Row>

        <Row className="text-center mb-5">
          {[
            { name: "[Team Member Name]", role: "Founder & CEO" },
            { name: "[Team Member Name]", role: "Lead AI Engineer" },
            { name: "[Team Member Name]", role: "UX/UI Designer" },
            { name: "[Team Member Name]", role: "Career Coach & Content Specialist" }
          ].map((member, index) => (
            <Col md={3} key={index} className="mb-4">
              <Card className="shadow-sm border-0">
                <Card.Body>
                  <Card.Title className="fw-bold">{member.name}</Card.Title>
                  <Card.Text>{member.role}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Mission Section */}
        <Row className="mb-5">
          <Col className="text-center">
            <h2 className="fw-bold">Our Mission</h2>
            <p className="fs-5">
              At [Your Tool Name], we aim to empower job seekers with smart, data-driven tools to create the best resume possible.
              Our mission is to bridge the gap between candidates and employers, helping you land your dream job.
            </p>
          </Col>
        </Row>

        {/* Call to Action */}
        <Row className="text-center">
          <Col>
            <Button variant="primary" size="lg" href="/get-started">Get Started Today</Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default About;
